<template>
  <v-card class="pa-4 reports-comments-panel elevation-0">
    <div class="reports-comments-panel__title d-flex align-center mb-6">
      <h5 class="text-h5 mr-2">{{ data?.comments }}</h5>
      <span class="text-subtitle-2">Comments</span>
    </div>

    <div class="d-flex gap-16">
      <Metrics
          :title="data?.helpful_commenters + ' users find your deal...'"
          outlined
          :is-loading="isLoading"
      >
        Helpful
      </Metrics>

      <Metrics
          :title="data?.funny_commenters + ' users find your deal...'"
          outlined
          :is-loading="isLoading"
      >
        Funny
      </Metrics>

      <Metrics
          :title="data?.like_commenters + ' users'"
          outlined
          :is-loading="isLoading"
      >
        Like your deal
      </Metrics>

      <!--Pseudo element-->
      <div class="full"></div>
    </div>
  </v-card>
</template>

<script>
import Metrics from "@/components/panels/reports/Metrics.vue";

export default {
  components: {Metrics},
  props: {
    data: {
      type: Object,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  }
}
</script>

<style lang="sass" scoped>

</style>
